import './setup/config';

(function acm() {
  window.acm = {
    recommend(configuration, requestOptions) {
      this.getRecommendations(
        configuration,
        requestOptions,
      );
    },

    recommendMultiple(configuration, widgetConfigs) {
      widgetConfigs.forEach(({ widgetId, requestOptions }) => {
        this.getRecommendationsForWidgetId(
          widgetId,
          configuration,
          requestOptions,
        );
      });
    },

    getRecommendationsForWidgetId(widgetId, configuration, requestOptions) {
      const { acmConfig } = configuration;

      for (const requestOption in requestOptions) {
        if (Object.prototype.hasOwnProperty.call(requestOptions, requestOption) && requestOptions[requestOption] === '') {
          delete requestOptions[requestOption];
        }
      }

      // perform call to the recommendation and fill the corresponding widget
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${window.ENV.RECOMMENDATION_URL}/recommendation`);
      xhr.setRequestHeader('X-API-KEY', acmConfig.apiToken);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify({
        ...requestOptions,
        types: requestOptions.types
          ? (typeof requestOptions.types === 'string' ? requestOptions.types.split(',') : requestOptions.types)
          : [],
        sources: requestOptions.sources
          ? (typeof requestOptions.sources === 'string' ? requestOptions.sources.split(',') : requestOptions.sources)
          : [],
        // TODO(pg): do we need app_ids here?
        categories: requestOptions.categories
          ? (typeof requestOptions.categories === 'string' ? requestOptions.categories.split(',') : requestOptions.categories)
          : [],
        weights: requestOptions.weights ? requestOptions.weights : {},
      }));

      xhr.onreadystatechange = function onReadyStateChangeFn() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);

          const containerElement = document.getElementById(widgetId)!;

          const listElement = document.createElement('div');
          listElement.id = 'acm-content-recommendations-container';
          listElement.className = 'acm-content-recommendations-container';
          containerElement.appendChild(listElement);

          for (let i = 0; i < response.items.length; i++) {
            listElement.appendChild(createArticle(
              configuration,
              requestOptions.reader_id,
              requestOptions.item_id,
              response,
              response.items[i],
            ));
          }
        } else if (xhr.status !== 200) {
          console.log(`Error: ${xhr.status}`);
        }
      };

      function calcDateDifference(oldDateString) {
        const MS_PER_DAY = 1000 * 60 * 60 * 24;
        const today = new Date();
        const date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
        const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;

        const dateTime = new Date(`${date} ${time}`);
        const oldDate = new Date(oldDateString);
        const utc1 = Date.UTC(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate());
        const utc2 = Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());
        const dateDifference = Math.floor((utc2 - utc1) / MS_PER_DAY);

        if (dateDifference >= 365) {
          const years = Math.floor(dateDifference / 365);
          if (years === 1) {
            return '1 year ago';
          } else {
            return `${years} years ago`;
          }
        }
        if (dateDifference >= 30) {
          return `${Math.floor(dateDifference / 30)} months ago`;
        } else if (dateDifference >= 1) {
          return `${dateDifference} days ago`;
        } else if (dateDifference < 1 && dateDifference >= 1 / 24) {
          return `${dateDifference * 24} hours ago`;
        } else if (dateDifference < 1 / 24) {
          return `${dateDifference * 24 * 60} minutes ago`;
        } else return '';
      }

      // eslint-disable-next-line @typescript-eslint/no-shadow
      function createArticle(configuration, reader_id, item_id, response, article) {
        const articlePadding = document.createElement('div');
        articlePadding.className = 'acm-content-recommendations-article-padding';

        const articleElement = document.createElement('article');
        articleElement.className = 'acm-content-recommendations-item';

        articlePadding.appendChild(articleElement);

        const imageElement = document.createElement('img');
        imageElement.style.backgroundImage = `url(${article.image_url})`;
        imageElement.className = 'acm-content-recommendations-image acm-content-recommendations-image-rsp';
        articleElement.appendChild(imageElement);

        const headerLineElement = document.createElement('div');
        headerLineElement.className = 'acm-content-recommendations-header-line';
        headerLineElement.innerHTML = article.title;
        articleElement.appendChild(headerLineElement);

        const infosElement = document.createElement('div');
        infosElement.className = 'acm-content-recommendations-infos';
        articleElement.appendChild(infosElement);

        if (article.source) {
          infosElement.appendChild(renderCaptionPoint(article.source.title, false));
        }

        // infosElement.appendChild(renderCaptionPoint(article.type ? article.type : 'article'));

        // if (article.sub_type) {
        //     infosElement.appendChild(renderCaptionPoint(article.sub_type));
        // }

        if (article.published) {
          infosElement.appendChild(renderCaptionPoint(calcDateDifference(article.published)));
        }

        if (article.last_modified && article.last_modified !== article.published) {
          infosElement.appendChild(renderCaptionPoint(calcDateDifference(article.last_modified)));
        }

        // if (article.author) {
        //     infosElement.appendChild(renderCaptionPoint(article.author));
        // }

        if (article.region) {
          infosElement.appendChild(renderCaptionPoint(article.region));
        }

        if (article.reading_time) {
          infosElement.appendChild(renderCaptionPoint(`${article.reading_time} min read`));
        }

        return articlePadding;
      }

      function renderCaptionPoint(content, showBullet = true) {
        const captionPointElement = document.createElement('span');
        captionPointElement.className = 'acm-content-recommendations-subtitle-container';

        if (showBullet) {
          const bulletPointElement = document.createElement('span');
          bulletPointElement.className = 'acm-content-recommendations-bullet-point '
                        + 'acm-content-recommendations-subtitle';
          bulletPointElement.innerText = '\u2022';
          captionPointElement.appendChild(bulletPointElement);
        }

        const subtitleElement = document.createElement('span');
        subtitleElement.className = 'acm-content-recommendations-subtitle';
        subtitleElement.innerHTML = content;
        captionPointElement.appendChild(subtitleElement);

        return captionPointElement;
      }
    },

    getRecommendations(configuration, requestOptions) {
      this.getRecommendationsForWidgetId(
        'acm-content-recommendations',
        configuration,
        requestOptions,
      );
    },
  };
}());

export {};
